import styled, { css } from 'styled-components';
import { ColorScheme, Colors, Fonts } from 'styles/constants';
import {
  BasePanel,
  BasePaginatorHeader,
  BasePaginatorListItem,
  Button,
} from 'styles/components';
export { WarehouseIcon } from 'styles/components';

export const MainPanel = styled(BasePanel)`
  padding: 32px;
  flex-direction: column;
`;

export const SaveButton = styled(Button)``;
export const RetryButton = styled(Button)``;

export const Description = styled.p`
  margin-bottom: 16px;
  color: ${ColorScheme.LightText};
  font-family: ${Fonts.GilroyRegular};
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  color: ${ColorScheme.Danger};
  font-family: ${Fonts.GilroySemiBold};
`;

export const SavedOnlyFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: ${ColorScheme.Text};
  font-family: ${Fonts.GilroySemiBold};

  label {
    cursor: pointer;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const grid = css`
  grid-template-columns: 60px minmax(280px, 1fr) minmax(180px, 240px);
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${grid}
`;

export const ListItem = styled(BasePaginatorListItem)`
  ${grid}
`;

export const Column = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AutomationColumn = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: normal;
`;

export const AutomationHeader = styled(AutomationColumn)`
  color: ${ColorScheme.Text};
  font-family: ${Fonts.GilroySemiBold};
  font-size: 11px;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: ${Colors.Orange};
`;
